(function(){

    $('.sym-slides').slick();

    document.querySelectorAll('p').forEach( e => {
        if (e.innerHTML.trim() === '') e.remove();
    });
    
}());